module.exports = __webpack_public_path__ + "media/gili/dock-72fd6092.jpg";